import { DOCUMENT, NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  IterableDiffers,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { DataStore } from '@compiere-ws/models/compiere-data-json';
import { LabelUiComponent } from '@iupics-components/standard/fields/label-ui/label-ui.component';
import { Global } from '@iupics-manager/models/global-var';
import { IupicsDataField } from '@iupics-manager/models/iupics-data';
import { OverridedCSS } from '@iupics-manager/models/overrided-css';
import { IupicsComponentType } from '@web-desktop/models/iupics-context-menu';
import { OverlayService, PrimeNGConfig } from 'primeng/api';
import { ConnectedOverlayScrollHandler, DomHandler } from 'primeng/dom';
import { TooltipModule } from 'primeng/tooltip';
import { ObjectUtils } from 'primeng/utils';
import { AutocompleteSuggestionsFilterPipe } from '../../pipes/autocomplete-suggestions-filter/autocomplete-suggestions-filter.pipe';
import { AutoComplete } from './autocomplete/autocomplete';

@Component({
  selector: 'iu-prime-autocomplete',
  templateUrl: './prime-autocomplete.component.html',
  styleUrls: ['./prime-autocomplete.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: Global.overlayAnimationAutocomplete,
  standalone: true,
  imports: [TooltipModule, NgClass, NgStyle, NgTemplateOutlet, LabelUiComponent, AutocompleteSuggestionsFilterPipe],
})
export default class PrimeAutocompleteComponent extends AutoComplete implements OnInit, OnDestroy {
  public autocompleteOverlayCSS = {
    width: '200px',
    top: '0px',
  };

  constructor(
    el: ElementRef,
    renderer: Renderer2,
    cd: ChangeDetectorRef,
    differs: IterableDiffers,
    config: PrimeNGConfig,
    overlayService: OverlayService
  ) {
    super(el, renderer, cd, differs, config, overlayService);
  }

  @Input()
  isStandalone = false;
  @Input()
  componentType = null;
  @Input()
  columnName: string;
  @Input()
  container: any;
  @Input()
  label: string;
  @Input()
  data: IupicsDataField;
  @Input()
  description: string;
  @Input()
  tabID: number;
  @Input()
  scrollHeight: string;
  @Input()
  iconClass: string;
  @Input()
  readonly: boolean;
  @Input()
  suggestionsFilter: any;
  @Input()
  isLabelDisplay: boolean;
  @Input()
  isEditorView = false;
  styleLess = input(false);

  mandatoryCss: string;
  formId;
  overlayBis: any;
  valueHasChanged = false;
  @Output()
  onLabelClickEmitter: EventEmitter<any> = new EventEmitter();
  @Output() selectItemEmitter: EventEmitter<any> = new EventEmitter();
  @Output() searchSelectEmitter: EventEmitter<any> = new EventEmitter();
  @Output() showSearchPanelEmitter: EventEmitter<any> = new EventEmitter();
  @Output() showFormPanelEmitter: EventEmitter<any> = new EventEmitter();
  @Input()
  dataStored: DataStore;
  iconeMandatoryCss: string;
  ObjectUtils = ObjectUtils;
  @ViewChild('wrapper', { read: ElementRef })
  wrapper: ElementRef;
  @Input() overridedCSS: OverridedCSS;
  // panel style
  @Input()
  isInsideOverflow = false;
  panelTop = '0px';
  panelLeft = '';

  @Input() appendTo: any = 'body';
  @Input() baseZIndex: number = 9999;

  hasZoom = false;
  preventLabelClick = input(false);

  #document = inject(DOCUMENT);

  ngOnInit() {
    this.hasZoom = [
      IupicsComponentType.ADDRESSFIELD,
      IupicsComponentType.FIELD,
      IupicsComponentType.FIELDZOOM,
    ].includes(this.componentType);
    if (!this.scrollHeight) {
      this.scrollHeight = '240px';
    }
    if (!this.iconClass) {
      this.iconClass = 'fa fa-search';
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  restoreOverlayAppend() {
    if (this.overlay && this.appendTo) {
      this.renderer.appendChild(this.el?.nativeElement, this.overlay);
    }
  }

  onInputBlur(event) {
    if (this.overlayVisible) {
      if (this.highlightOption) {
        this.selectItem(this.highlightOption);
      } else {
        this.hide();
      }
      this.focus = false;
    } else {
      this.focus = false;
      this.onModelTouched();
      this.onBlur.emit();
    }
    // TODO: find a better way to handle use case :
    // When typing a value that match one suggestions and then clear the input
    // without unfocusing it, inputFieldValue keep the matching suggestion
    // even if the actual input value is ''
    if (this.inputFieldValue != undefined && event.target.value.trim() !== this.inputFieldValue) {
      // This make the input value match inputFieldValue for this case
      event.target.value = this.inputFieldValue;
    }
  }

  hide() {
    this.overlayVisible = false;
    this.onBlur.emit();
    this.cd.markForCheck();
  }

  onInputChange(event) {
    if (!this.valueHasChanged) {
      if (this.suggestions && this.suggestions.length === 1) {
        if (this.multiple) {
          if (this.multiInputEL?.nativeElement) {
            this.multiInputEL.nativeElement.value = '';
          }
          this.value = this.value || [];
          if (!this.isSelected(this.suggestions[0])) {
            if (this.value && Array.isArray(this.value)) {
              this.value = [...this.value, this.suggestions[0]];
            } else {
              this.value = [this.suggestions[0]];
            }
            this.onModelChange(this.value);
          }
        } else {
          if (this.inputEL?.nativeElement) {
            this.inputEL.nativeElement.value = this.field
              ? ObjectUtils.resolveFieldData(this.suggestions[0], this.field) || ''
              : this.suggestions[0].displayValue;
          }
          this.value = this.suggestions[0];
          this.onModelChange(this.value);
          this.hide();
        }
        this.onSelect.emit(this.suggestions[0]);
        this.updateFilledState();
        this._suggestions = null;
        this.updateInputField();
      } else if (this.highlightOption) {
        this.selectItem(this.highlightOption);
        this.hide();
      } else if (this.multiple) {
        if (this.multiInputEL?.nativeElement) {
          this.multiInputEL.nativeElement.value = '';
        }
      } else {
        if (event.target) {
          event.target.value = '';
        }
        this.value = null;
        this.onSelect.emit(null);
      }
    }
    this.valueHasChanged = false;
  }

  handleSuggestionsChange() {
    if (this._suggestions != null) {
      this.highlightOption = null;
      // filter first: a list emptied by the filter shows the empty message, not an empty panel
      if (this.suggestionsFilter) {
        this._suggestions = this._suggestions.filter((suggestion) =>
          this.suggestionsFilter(suggestion, this.data.columnName)
        );
      }
      if (this._suggestions.length) {
        this.noResults = false;
        this.show();
        this.suggestionsUpdated = true;

        if (this.autoHighlight) {
          this.highlightOption = this._suggestions[0];
        }
      } else {
        this.noResults = true;

        if (this.emptyMessage) {
          this.show();
          this.suggestionsUpdated = true;
        } else {
          this.hide();
        }
      }
      this.loading = false;
    }
  }

  selectItem(option: any, focus: boolean = true) {
    if (this.forceSelectionUpdateModelTimeout) {
      clearTimeout(this.forceSelectionUpdateModelTimeout);
      this.forceSelectionUpdateModelTimeout = null;
    }
    if (option.id !== -1 && option.id !== -2) {
      let sameValue = false;
      if (this.value && this.value.id === option.id) {
        sameValue = true;
      }
      if (!sameValue) {
        if (this.multiple) {
          if (this.multiInputEL?.nativeElement) {
            this.multiInputEL.nativeElement.value = '';
          }
          this.value = this.value || [];
          if (!this.isSelected(option)) {
            this.value = [...this.value, option];
            this.onModelChange(this.value);
          }
        } else {
          if (this.inputEL?.nativeElement) {
            this.inputEL.nativeElement.value = this.field
              ? ObjectUtils.resolveFieldData(option, this.field) || ''
              : option.displayValue;
          }
          this.value = option;
          this.onModelChange(this.value);
          this.selectItemEmitter.emit();
        }
        this.onSelect.emit(option);
        this.updateFilledState();
        this._suggestions = null;
        this.updateInputField();
      }
      this.hide();
    } else if (option.id === -2) {
      if (this.value !== null && this.value !== undefined) {
        if (this.inputEL?.nativeElement) {
          this.inputEL.nativeElement.value = null;
        }
        this.value = null;
        this.onModelChange(null);
        this.selectItemEmitter.emit();
        this.hide();
        this.onSelect.emit(null);
        this.updateFilledState();
        this._suggestions = null;
        this.updateInputField();
      }
    } else if (this.checkSpecificView()) {
      this.showFormPanel();
      this.hide();
    } else {
      this.openSearchPanel();
      this.hide();
    }
    this.onBlur.emit();
  }

  openSearchPanel() {
    this.showSearchPanelEmitter.emit();
  }

  checkSpecificView() {
    if (this?.data?.formId) {
      this.formId = this.data.formId;
      return true;
    } else {
      return false;
    }
  }

  showFormPanel() {
    this.showFormPanelEmitter.emit(this.formId);
  }

  appendOverlay() {
    if (this.appendTo) {
      if (this.appendTo === 'body') {
        this.renderer.appendChild(this.#document.body, this.overlay);
      } else {
        DomHandler.appendChild(this.overlay, this.appendTo);
      }

      if (!this.overlay.style.width) {
        this.overlay.style.width = DomHandler.getWidth(this.el?.nativeElement.children[0]) + 'px';
      }
    }
  }

  updateInputField() {
    const formattedValue = this.value
      ? this.field
        ? ObjectUtils.resolveFieldData(this.value, this.field) || ''
        : this.value.displayValue
      : '';
    this.inputFieldValue = formattedValue;
    if (this?.inputEL?.nativeElement) {
      // Si probleme autocomplete décommenter
      this.valueHasChanged = true;
      this.inputEL.nativeElement.value = formattedValue || '';
    }

    this.updateFilledState();
  }

  setMandatoryCss(css: string) {
    this.mandatoryCss = css;
  }

  handleWheel(event: WheelEvent) {
    event.stopPropagation();
    if (event.deltaY > 0) {
      if (
        this.wrapper?.nativeElement.scrollWidth -
          this.wrapper?.nativeElement.scrollLeft -
          this.wrapper?.nativeElement.clientWidth >
        0
      ) {
        this.wrapper?.nativeElement.scrollTo({ left: this.wrapper?.nativeElement.scrollLeft + 25 });
      }
    } else if (this.wrapper?.nativeElement.scrollLeft !== 0) {
      this.wrapper?.nativeElement.scrollTo({ left: this.wrapper?.nativeElement.scrollLeft - 25 });
    }
  }

  onKeyup(event: any) {
    // event.which === 8
    if (event.key === 'Backspace') {
      // Route through the same debounce mechanism as onInput (this.timeout/this.delay) instead of
      // calling search immediately, so rapid backspacing does not fire one uncached HTTP request
      // per keystroke and does not race with a pending debounced search from onInput.
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      const value = this.inputFieldValue?.length > 1 && event.target.value === '' ? ' ' : event.target.value;
      this.timeout = setTimeout(() => {
        this.search(event, value);
      }, this.delay);
    }
    super.onKeyup(event);
  }

  onKeydown(event) {
    if (this.overlayVisible) {
      const highlightItemIndex = this.findOptionIndex(this.highlightOption, this.suggestions);
      switch (event.which) {
        // down
        case 40:
          if (highlightItemIndex != -1) {
            const nextItemIndex = highlightItemIndex + 1;
            if (nextItemIndex != this.suggestions.length) {
              this.highlightOption = this.suggestions[nextItemIndex];
              this.highlightOptionChanged = true;
            }
          } else {
            this.highlightOption = this.suggestions[0];
          }
          event.preventDefault();
          break;
        // up
        case 38:
          if (highlightItemIndex > 0) {
            const prevItemIndex = highlightItemIndex - 1;
            this.highlightOption = this.suggestions[prevItemIndex];
            this.highlightOptionChanged = true;
          }
          event.preventDefault();
          break;
        // enter
        case 13:
          if (this.highlightOption) {
            this.selectItem(this.highlightOption);
            this.hide();
          }
          event.preventDefault();
          break;
        // escape
        case 27:
          this.hide();
          event.preventDefault();
          break;
        // tab
        case 9:
          if (this.highlightOption) {
            this.selectItem(this.highlightOption);
          }
          this.hide();
          break;
      }
    } else if (event.which === 40 && this.suggestions) {
      this.search(event, event.target.value);
    }

    if (this.multiple && event.which === 8) {
      if (this?.value?.length && !this.multiInputEL?.nativeElement.value) {
        this.value = [...this.value];
        const removedValue = this.value.pop();
        this.onModelChange(this.value);
        this.updateFilledState();
        this.onUnselect.emit(removedValue);
      }
    }
    this.inputKeyDown = true;
  }

  onInput(event: Event) {
    this.valueHasChanged = false;
    // When an input element with a placeholder is clicked, the onInput event is invoked in IE.
    if (!this.inputKeyDown && DomHandler.isIE()) {
      return;
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    const value = (<HTMLInputElement>event.target).value;
    if (!this.multiple && !this.forceSelection) {
      this.onModelChange(value);
    }
    if (value.length === 0 && !this.multiple) {
      this.hide();
      this.onClear.emit(event);
      this.onModelChange(value);
    }
    if (value.length >= this.minLength) {
      this.timeout = setTimeout(() => {
        this.search(event, value);
      }, this.delay);
    } else {
      this.suggestions = null;
      this.hide();
    }
    this.updateFilledState();
    this.inputKeyDown = false;
  }

  bindScrollListener() {
    if (!this.scrollHandler) {
      this.scrollHandler = new ConnectedOverlayScrollHandler(this.containerEL?.nativeElement, () => {
        if (this.overlayVisible) {
          this.hide();
          if (this.multiInputEL) {
            this.multiInputEL?.nativeElement.blur();
          }
          if (this.inputEL) {
            this.inputEL?.nativeElement.blur();
          }
        }
      });
    }

    this.scrollHandler.bindScrollListener();
  }

  unbindScrollListener() {
    if (this.scrollHandler) {
      this.scrollHandler.unbindScrollListener();
    }
  }
  focusInput() {
    const inputEL: HTMLElement = this.inputEL?.nativeElement;
    if (inputEL && !this.isElementInViewport(inputEL)) {
      const parentEl: HTMLElement = this.getScrollParent(this.inputEL.nativeElement);
      const parentRect = parentEl.getBoundingClientRect();
      const inputRect = inputEL.getBoundingClientRect();
      const scrollTop = inputRect.top - parentRect.top + parentEl.scrollTop;

      parentEl.scrollTo({
        top: scrollTop,
        behavior: 'auto',
      });

      setTimeout(this._focus, 10);
    } else {
      this._focus();
    }
  }
}
